import React, { Component } from "react";
import { withSnackbar } from "notistack";
import { connect } from "react-redux";
import { DriftMarker } from "leaflet-drift-marker";

//Leaflet
import { Tooltip, Marker } from "react-leaflet";
import L from "leaflet";

import MapPopup from "./MapPopup";

import { API_Map } from "../../../apihandler/Map";
import { MAP_ACTIONS } from "../../../actions/MapActions";
import { CONFIG, UNITS } from "../../../common/consts";
import { dateFunction } from "common/datefunctions";

class FleetMarker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
    };
  }

  getMapMarker = ({ status, angle, imei, mapicon, arrow, icon }) => {
    let iconUrl = CONFIG.BASE_URL + icon;
    let customMarker = null;
    let width = CONFIG.MAP_ARROW_SIZE;
    if (mapicon === "arrow") {
      if (status === 0 || status === 1) {
        iconUrl = "https://fleetlogix.vaschan.com/img/markers/arrow_red.png";
      } else if (status === 2) {
        iconUrl = "https://fleetlogix.vaschan.com/img/markers/arrow_yellow.png";
      } else if (status === 3) {
        iconUrl = "https://fleetlogix.vaschan.com/img/markers/arrow_green.png";
      }
    } else {
      iconUrl = CONFIG.BASE_URL + arrow;
      width = CONFIG.MAP_CUSTOM_ARROW_SIZE;
    }

    const html =
      "<div class='movingMarker' id='movingmarker-" +
      imei +
      "' style='transform: rotate(" +
      angle.toString() +
      "deg);'><img src='" +
      iconUrl +
      "' alt='' width='" +
      width +
      "px'/></div>";

    customMarker = L.divIcon({
      html: html,
      iconSize: new L.Point(16, 16),
      iconAnchor: null,
      popupAnchor: [0, -3],
      className: "mapMarker",
    });

    return customMarker;
  };

  mapClick = (e) => {};

  markerClick = (imei) => {
    this.props.setSelectedVehicle({
      selectedVehicle: imei,
    });

    let self = this;
    API_Map.getVehicleData({ imei: imei }).then((res) => {
      if (res.Result === 200) {
        self.setState({
          data: res.Response,
        });
      }
    });
  };

  shouldComponentUpdate(props, state) {
    const { imei } = this.props;
    const { vehiclesList, animationVehiclesList } = this.props.commonReducer;
    const { markerAnimation, liveMarkerAnimation } = this.props.mapReducer;

    let vehiclesListOld = props.commonReducer.vehiclesList;
    if (animationVehiclesList.length > 0) {
      vehiclesListOld = props.commonReducer.animationVehiclesList;
    }

    let rslt = false;

    let vehicleNew = [];
    if (liveMarkerAnimation) {
      vehicleNew = animationVehiclesList.filter((v) => {
        return v.imei === imei;
      });
    } else {
      vehicleNew = vehiclesList.filter((v) => {
        return v.imei === imei;
      });
    }

    let vehicleOld = [];
    if (vehiclesListOld.length) {
      vehicleOld = vehiclesListOld.filter((v) => {
        return v.imei === imei;
      });
    }

    if (state.data.time) {
      if (this.state.data.time) {
        rslt = state.data.time.lastupdate !== this.state.data.time.lastupdate;
      } else {
        rslt = true;
      }
    }

    if (!rslt && vehicleNew.length > 0 && vehicleOld.length > 0) {
      rslt =
        vehicleOld[0].latitude !== vehicleNew[0].latitude ||
        vehicleOld[0].longitude !== vehicleNew[0].longitude;
    }

    if (!rslt) {
      if (animationVehiclesList.length > 0) {
        rslt = liveMarkerAnimation !== props.mapReducer.liveMarkerAnimation;
      } else {
        rslt = markerAnimation !== props.mapReducer.markerAnimation;
      }
    }

    return rslt;
  }

  render() {
    const { data } = this.state;
    const { imei, showTrack, shareVehicle } = this.props;
    const { vehiclesList, animationVehiclesList } = this.props.commonReducer;
    const { markerAnimation, liveMarkerAnimation } = this.props.mapReducer;

    let vehicle = [];
    if (animationVehiclesList.length > 0) {
      vehicle = animationVehiclesList.filter((v) => {
        return v.imei === imei;
      });
    } else {
      vehicle = vehiclesList.filter((v) => {
        return v.imei === imei;
      });
    }
    if (vehicle.length > 0) {
      vehicle = vehicle[0];
    } else {
      return null;
    }

    const pos = [vehicle.latitude, vehicle.longitude];
    const latLng = { lat: vehicle.latitude, lng: vehicle.longitude };

    let vehicleName =
      vehicle.name + " (" + vehicle.speed.toFixed(1) + " " + UNITS.SPEED + ")";
    if (vehicle.speed === 0) {
      if (vehicle.idletime != null) {
        let idleSince = dateFunction.getDateDiffString(
          dateFunction.getDateDiff(vehicle.idletime),
          false
        );
        vehicleName = vehicle.name + " (" + idleSince + ")";
      }
    }

    console.log("vehicleName: ", vehicle.idletime);

    return markerAnimation || liveMarkerAnimation ? (
      <DriftMarker
        // if position changes, marker will drift its way to new position
        position={latLng}
        // time in ms that marker will take to reach its destination
        duration={30 * 1000}
        icon={this.getMapMarker(vehicle)}
      >
        {/* <MapPopup vehicle={vehicle} data={data} showTrack={showTrack} /> */}
        {/* <Tooltip>Hi here is a tooltip</Tooltip> */}
      </DriftMarker>
    ) : (
      <Marker
        position={pos}
        icon={this.getMapMarker(vehicle)}
        key={"mapMarker-" + vehicle.imei}
        ref={vehicle.imei}
        onclick={() => this.markerClick(vehicle.imei)}
        className="mapMarker"
      >
        <MapPopup
          vehicle={vehicle}
          data={data}
          showTrack={showTrack}
          shareVehicle={shareVehicle}
        />
        <Tooltip
          direction="right"
          offset={[10, -2]}
          permanent
          className={"makerLabel"}
        >
          <span>{vehicleName}</span>
        </Tooltip>
      </Marker>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    commonReducer: state.commonReducer,
    mapReducer: state.mapReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSelectedVehicle: (values) => {
      dispatch({
        type: MAP_ACTIONS.SELECT_VEHICLE,
        values,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbar(FleetMarker));
